export default __webpack_public_path__ + "static/media/EDISON_MC-DS-release2-v03.9820c949.pdf";